/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type { DeleteUserOptions, DeleteUserResponses } from '../types/DeleteUser'
import { client, withUnwrap } from '../.kubb/client'

/**
 * @summary Delete user by ID
 * {@link /v1/user/:user_id}
 */
export function deleteUser<ThrowOnError extends boolean = true>(
  options: Options<DeleteUserOptions, ThrowOnError>,
): Unwrappable<RequestResult<DeleteUserResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(
    request({
      method: 'DELETE',
      url: '/v1/user/{user_id}',
      security: [
        { type: 'http', scheme: 'bearer' },
        { type: 'apiKey', name: 'Authorization', in: 'header' },
      ],
      ...config,
      throwOnError: config.throwOnError ?? true,
    }) as Promise<RequestResult<DeleteUserResponses, ThrowOnError>>,
  )
}
